import { expectArray, expectNumber, expectOptionalString, expectRecord, expectString } from "./schema";
export const STUDENT_SELF_INVITE_STATUSES = ["active", "consumed", "expired", "revoked"];
function parseStringEnum(value, allowedValues, path) {
    const parsed = expectString(value, path);
    if (!allowedValues.includes(parsed)) {
        throw new Error(`${path} must be one of: ${allowedValues.join(", ")}`);
    }
    return parsed;
}
function hasOwn(record, key) {
    return Object.prototype.hasOwnProperty.call(record, key);
}
function parsePositiveIntegerOrNull(value, path) {
    if (value === null || value === undefined) {
        return null;
    }
    const parsed = expectNumber(value, path);
    if (!Number.isInteger(parsed) || parsed <= 0) {
        throw new Error(`${path} must be a positive integer`);
    }
    return parsed;
}
export function parseStudentSelfInviteStatus(value, path = "studentSelfInviteStatus") {
    return parseStringEnum(value, STUDENT_SELF_INVITE_STATUSES, path);
}
export function parseStudentSelfInviteDeliveryArtifacts(value, path = "studentSelfInviteDeliveryArtifacts") {
    const record = expectRecord(value, path);
    return {
        inviteUrl: expectString(record.inviteUrl, `${path}.inviteUrl`)
    };
}
export function parseAdminStudentSelfInvite(value, path = "adminStudentSelfInvite") {
    const record = expectRecord(value, path);
    return {
        inviteId: expectString(record.inviteId, `${path}.inviteId`),
        inviteType: "studentSelf",
        studentId: expectString(record.studentId, `${path}.studentId`),
        studentDisplayName: expectOptionalString(record.studentDisplayName, `${path}.studentDisplayName`),
        status: parseStudentSelfInviteStatus(record.status, `${path}.status`),
        maxUseCount: expectNumber(record.maxUseCount, `${path}.maxUseCount`),
        usedCount: expectNumber(record.usedCount, `${path}.usedCount`),
        remainingUseCount: expectNumber(record.remainingUseCount, `${path}.remainingUseCount`),
        expiresAt: expectString(record.expiresAt, `${path}.expiresAt`),
        createdByPlatformUserId: expectOptionalString(record.createdByPlatformUserId, `${path}.createdByPlatformUserId`),
        consumedByPlatformUserId: expectOptionalString(record.consumedByPlatformUserId, `${path}.consumedByPlatformUserId`),
        consumedAt: expectOptionalString(record.consumedAt, `${path}.consumedAt`),
        createdAt: expectString(record.createdAt, `${path}.createdAt`),
        updatedAt: expectString(record.updatedAt, `${path}.updatedAt`)
    };
}
export function parseAdminStudentSelfInvitesResponse(value, path = "adminStudentSelfInvitesResponse") {
    const record = expectRecord(value, path);
    return {
        items: expectArray(record.items, parseAdminStudentSelfInvite, `${path}.items`)
    };
}
export function parseCreateAdminStudentSelfInviteRequest(value, path = "createAdminStudentSelfInviteRequest") {
    const record = expectRecord(value, path);
    return {
        studentId: expectString(record.studentId, `${path}.studentId`),
        expiresAt: expectOptionalString(record.expiresAt, `${path}.expiresAt`),
        maxUseCount: hasOwn(record, "maxUseCount")
            ? parsePositiveIntegerOrNull(record.maxUseCount, `${path}.maxUseCount`)
            : null
    };
}
export function parseCreateAdminStudentSelfInviteResponse(value, path = "createAdminStudentSelfInviteResponse") {
    const record = expectRecord(value, path);
    return {
        invite: parseAdminStudentSelfInvite(record.invite, `${path}.invite`),
        delivery: parseStudentSelfInviteDeliveryArtifacts(record.delivery, `${path}.delivery`)
    };
}
export function parseConsumeStudentSelfInviteRequest(value, path = "consumeStudentSelfInviteRequest") {
    const record = expectRecord(value, path);
    return {
        token: expectString(record.token, `${path}.token`)
    };
}
